import styled from 'styled-components';

export const ExpenseOverviewContainer = styled.div`
    width: 25rem;
`;
